<template>
<div class="chapter">
<div class="inner_page">
<h1><a id="page1"></a><a href="#/005toc#int">Introduction</a></h1>
<p class="center"><em>Written for busy people who expect good results with a minimum amount of time in the kitchen, these recipes include tempting hors d’oeuvres, satisfying soups, creative salads, terrific entrées, quick pasta and grain dishes, and desserts that will appeal to the beginner as well as the experienced cook.</em></p>
<p class="center"><em>Every entrée has menu suggestions; some have helpful hints and other information. The recipes are straightforward and practical with complete, easy-to-follow directions that make cooking fun and easy</em>.</p>
<p class="center"><em>Most ingredients are readily available and fresh ingredients are used whenever possible. Today’s cooks are more health conscious and aware of good nutrition, so reduced cholesterol, fat, and calories are taken into consideration.</em></p>
<p class="center"><em>This is a cookbook that will soon become your favorite.</em></p>
<div class="image">
<p class="center"><img alt="image 11" src="images/image-11.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-introduction.vue?7094c0a5